import { IonReactRouter } from "@ionic/react-router";
import { Navigate, Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";

import "./Router.scss";
import * as routes from "../constants/routes";
import { ForgotPassword } from "../pages/ForgotPassword/ForgotPassword";
import { WebSignUp as SinglePageWebSignUp } from "../pages/SinglePageWebSignUp/WebSignUp";
import { WebPaymentLanding } from "../pages/WebPaymentLanding/WebPaymentLanding";
import WebOneOffSignupRedirect from "./WebOneOffSignupRedirect";
import { ResetPassword } from "../pages/ResetPassword/ResetPassword";
import { WebReferralLanding } from "../pages/WebReferralLanding/WebReferralLanding";
import { CancelSubscription } from "../pages/CancelSubscription/CancelSubscription";
import WelcomeBack from "../pages/WelcomeBack/WelcomeBack";
import PurchaseWeb from "../pages/PurchaseWeb/PurchaseWeb";
import { ShopifyApp } from "../pages/ShopifyApp/ShopifyApp";
import SurveyQuestionnaire from "../pages/SurveyQuestionnaire/SurveyQuestionnaire";
import LoginOTP from "../pages/LoginOTP";
import { useWebLogRocketProvider } from "../hooks/useWebLogRocketProvider";

const WebLogRocketRecording = () => {
  useWebLogRocketProvider();
  return null;
};

export const RouterComponent = () => {
  return (
    <IonReactRouter>
      <WebLogRocketRecording />
      <IonRouterOutlet>
        <Route path={routes.WEB_SIGN_UP_V6} element={<SinglePageWebSignUp />} />

        <Route
          path={routes.WEB_SIGN_UP_V6_ONE_OFF}
          element={<WebOneOffSignupRedirect />}
        />

        <Route path={`${routes.WEB_PAYMENT}/*`} element={<PurchaseWeb />} />
        <Route path={routes.WEB_OTP} element={<LoginOTP />} />

        <Route
          path={routes.WEB_CANCEL_SUBSCRIPTION}
          element={<CancelSubscription />}
        />

        <Route path={routes.WELCOME_BACK} element={<WelcomeBack />} />

        <Route path={routes.WEB_REFERRAL} element={<WebReferralLanding />} />

        <Route
          path={routes.SURVEY_QUESTIONNAIRE}
          element={<SurveyQuestionnaire />}
        />

        <Route
          path={`${routes.WEB_DOWNLOAD_APP}/*`}
          element={<WebPaymentLanding />}
        />

        <Route path={routes.RESET_PASSWORD} element={<ResetPassword />} />
        <Route path={routes.FORGOT_PASSWORD} element={<ForgotPassword />} />

        <Route path={routes.PARTNER_APP} element={<ShopifyApp />} />

        <Route
          path="/"
          element={
            <Navigate
              to={routes.WEB_SIGN_UP_V6.replace(":subscriptionKey", "mvp")}
              replace
            />
          }
        />

        <Route
          path="*"
          element={
            <Navigate
              to={routes.WEB_SIGN_UP_V6.replace(":subscriptionKey", "mvp")}
              replace
            />
          }
        />
      </IonRouterOutlet>
    </IonReactRouter>
  );
};
